import {VideoPlayer} from "@/components/layouts/page/VideoPlayer";
import {Overlay} from "@/components/layouts/popup/Overlay";

import videoBtn from "@images/cards/play.svg";
import closeImg from "@images/popups/close-white.svg";

import styles from "./styles.module.scss";

export const VideoPopup = ({video, onClick}) => {
  return (
    <Overlay color={"rgba(65, 64, 64, 0.6)"}>
      <div className={styles.videoPopup}>
        <div
          onClick={onClick}
          className={styles.close}
        >
          <img
            src={closeImg}
            alt={"close"}
          />
        </div>

        <h2 dangerouslySetInnerHTML={{__html: video.title}} />

        <VideoPlayer
          playBtnImg={videoBtn}
          playBtnSize={80}
          video={video}
        />
      </div>
    </Overlay>
  );
};
